export enum ReportNames {
  addressLabel = 'Address Label',
  creditNote = 'Credit Note',
  customerStockLabel = 'Customer Stock Label',
  depositInvoice = 'Deposit Invoice',
  despatchNote = 'Despatch Note',
  locationLabel = 'Location Label',
  pickingList = 'Picking List',
  proformaInvoice = 'Proforma Invoice',
  purchaseContract = 'Purchase Contract',
  purchaseDespatch = 'Purchase Despatch',
  purchaseInvoice = 'Purchase Invoice',
  purchaseOrder = 'Purchase Order',
  salesBackOrder = 'Sales Back Order',
  salesContract = 'Sales Contract',
  salesDespatchNote = 'Sales Despatch Note',
  salesInvoice = 'Sales Invoice',
  salesManifest = 'Sales Manifest',
  salesOrderBalances = 'Sales Order Balances',
  salesOrderConfirmation = 'Sales Order Confirmation',
  salesPack = 'Sales Pack',
  salesQuotation = 'Sales Quotation',
  stockLabel = 'Stock Label',
  supplierPickingList = 'Supplier Picking List',
  supplierStockLabel = 'Supplier Stock Label',
}
